<template>
  <modal back="edit-text" :title="$t('customization.changeFont')">
    <div class="TextFontSelectorView">
      <base-row
        v-for="font of fonts"
        :key="font.key"
        class="h-12 relative flex justify-center py-2 items-center"
      >
        <a
          class="block float-none bg-no-repeat bg-contain bg-center h-full w-5/6 hover:cursor-pointer"
          :style="{
            backgroundImage: `url('${fontImage(font.key)}')`
          }"
          @click="closeModalAfter(() => changeFont(font.key))"
        />
        <div class="absolute pin-r">
          <base-icon
            v-if="font.key === activeElement.font"
            size="xs"
            name="check-icon"
          />
        </div>
      </base-row>
    </div>
  </modal>
</template>
<script>
import Modal from '../../components/Modal.vue';
import { TrackingMixin } from '../../mixins/gtm-tracking';
import {
  GETTER_FONT_IMAGE,
  GETTER_FONT_LIST_BY_PRINTSTYLE
} from '@/store/modules/font/getters';
import { GETTER_ACTIVE_PRINT_SIDE_PRINT_STYLE } from '../../store/getters';
import Redirect from '@/mixins/redirect';
import ActiveElement from '@/mixins/activeElement';

export default {
  name: 'TextFontSelectorView',
  components: {
    Modal
  },
  mixins: [TrackingMixin, Redirect, ActiveElement],
  computed: {
    fonts() {
      return this.$store.getters[GETTER_FONT_LIST_BY_PRINTSTYLE](
        this.$store.getters[GETTER_ACTIVE_PRINT_SIDE_PRINT_STYLE]
      ).filter(font => font.active); // SS-5631
    }
  },
  methods: {
    fontImage(fontId) {
      return this.$store.getters[GETTER_FONT_IMAGE](fontId);
    },
    changeFont(fontId) {
      this.updateElement({
        font: fontId
      });
      this.trackEvent({
        action: 'Text_ChangeTextFont',
        label: `${this.activeElement.font}:${fontId}`
      });
    }
  }
};
</script>
